"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyNoticeModalType = exports.DataProcessingTable = void 0;
const lib_1 = require("@brandfree-front/lib");
const react_1 = __importDefault(require("react"));
const RootStore_1 = require("../../../stores/RootStore");
const DataProcessingTable = (props) => {
    const { translate } = react_1.default.useContext(RootStore_1.RootStoreContext).translateStore;
    return (react_1.default.createElement(lib_1.Table, { minWidth: 400 },
        react_1.default.createElement("thead", null,
            react_1.default.createElement(lib_1.TableRow, null,
                react_1.default.createElement(lib_1.TableCell, { type: "th", scope: "col" }, translate('gdpr.privacy.notification.paragraph.data.processing.table.header1')),
                react_1.default.createElement(lib_1.TableCell, { type: "th", scope: "col" }, translate('gdpr.privacy.notification.paragraph.data.processing.table.header2')))),
        react_1.default.createElement("tbody", null, props.data.map((row, key) => (react_1.default.createElement(lib_1.TableRow, { key: key },
            react_1.default.createElement(lib_1.TableCell, null, row.content),
            react_1.default.createElement(lib_1.TableCell, { valign: "top" }, row.type)))))));
};
exports.DataProcessingTable = DataProcessingTable;
var PrivacyNoticeModalType;
(function (PrivacyNoticeModalType) {
    PrivacyNoticeModalType[PrivacyNoticeModalType["BASIC_INFO"] = 0] = "BASIC_INFO";
    PrivacyNoticeModalType[PrivacyNoticeModalType["COMMUNICATION"] = 1] = "COMMUNICATION";
    PrivacyNoticeModalType[PrivacyNoticeModalType["LOCATION"] = 2] = "LOCATION";
    PrivacyNoticeModalType[PrivacyNoticeModalType["MESSAGE"] = 3] = "MESSAGE";
    PrivacyNoticeModalType[PrivacyNoticeModalType["COMMUNICATION_WITH_TELIA"] = 4] = "COMMUNICATION_WITH_TELIA";
    PrivacyNoticeModalType[PrivacyNoticeModalType["PERSONAL_DATA"] = 5] = "PERSONAL_DATA";
    PrivacyNoticeModalType[PrivacyNoticeModalType["KIDS"] = 6] = "KIDS";
    PrivacyNoticeModalType[PrivacyNoticeModalType["NON_PERSONAL"] = 7] = "NON_PERSONAL";
    PrivacyNoticeModalType[PrivacyNoticeModalType["ANONYMOUS"] = 8] = "ANONYMOUS";
    PrivacyNoticeModalType[PrivacyNoticeModalType["COLLECT_DATA"] = 9] = "COLLECT_DATA";
    PrivacyNoticeModalType[PrivacyNoticeModalType["DATA_PROCESSING"] = 10] = "DATA_PROCESSING";
    PrivacyNoticeModalType[PrivacyNoticeModalType["DATA_PROCESSING_CONTRACT"] = 11] = "DATA_PROCESSING_CONTRACT";
    PrivacyNoticeModalType[PrivacyNoticeModalType["DATA_PROCESSING_LEGAL"] = 12] = "DATA_PROCESSING_LEGAL";
    PrivacyNoticeModalType[PrivacyNoticeModalType["DATA_PROCESSING_WITH_CONSENT"] = 13] = "DATA_PROCESSING_WITH_CONSENT";
    PrivacyNoticeModalType[PrivacyNoticeModalType["MARKETING_PROFILING"] = 14] = "MARKETING_PROFILING";
    PrivacyNoticeModalType[PrivacyNoticeModalType["CREDIT_RATING"] = 15] = "CREDIT_RATING";
    PrivacyNoticeModalType[PrivacyNoticeModalType["DEBT_MANAGEMENT"] = 16] = "DEBT_MANAGEMENT";
    PrivacyNoticeModalType[PrivacyNoticeModalType["PERSONAL_DATA_PRINCIPLE"] = 17] = "PERSONAL_DATA_PRINCIPLE";
    PrivacyNoticeModalType[PrivacyNoticeModalType["THIRD_PARTY_DATA"] = 18] = "THIRD_PARTY_DATA";
    PrivacyNoticeModalType[PrivacyNoticeModalType["PROTECT_PERSONAL_DATA"] = 19] = "PROTECT_PERSONAL_DATA";
    PrivacyNoticeModalType[PrivacyNoticeModalType["RIGHTS_PERSONAL_DATA"] = 20] = "RIGHTS_PERSONAL_DATA";
})(PrivacyNoticeModalType || (exports.PrivacyNoticeModalType = PrivacyNoticeModalType = {}));
